import React from "react";
import { Modal, Form, DatePicker } from "antd";
import dayjs from "dayjs";

// 부모에서 user가 바뀔 때마다 key로 fresh mount하기 때문에
// useEffect/setFieldsValue 같은 race condition 없이 initialValues로 충분.
function LicenseEditModal({ user, onCancel, onSave }) {
  const [form] = Form.useForm();

  const handleOk = async () => {
    const values = await form.validateFields();
    onSave({
      kla_expiration: values.kla_expiration
        ? values.kla_expiration.format("YYYY-MM-DD")
        : null,
      sle_expiration: values.sle_expiration
        ? values.sle_expiration.format("YYYY-MM-DD")
        : null,
    });
  };

  return (
    <Modal
      title={`라이센스 수정 — ${user?.name || user?.email || ""}`}
      open
      onOk={handleOk}
      onCancel={onCancel}
      okText="저장"
      cancelText="취소"
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          kla_expiration: user?.kla_expiration ? dayjs(user.kla_expiration) : null,
          sle_expiration: user?.sle_expiration ? dayjs(user.sle_expiration) : null,
        }}
      >
        <Form.Item label="KLA 만료일" name="kla_expiration">
          <DatePicker style={{ width: "100%" }} placeholder="만료일 선택" />
        </Form.Item>
        <Form.Item label="SLE 만료일" name="sle_expiration">
          <DatePicker style={{ width: "100%" }} placeholder="만료일 선택" />
        </Form.Item>
        <p style={{ color: "var(--text-secondary, #888)", fontSize: 12, margin: 0 }}>
          만료일을 비우면 해당 라이센스를 회수합니다 (NULL로 저장).
        </p>
      </Form>
    </Modal>
  );
}

export default LicenseEditModal;
